import * as React from 'react';
import { translation } from '../../i18n';
import ErrorPage from './ErrorPage';

class ForbiddenPage extends React.Component<{}> {

  public render() {
    return (
      <ErrorPage content={translation.t('errors.forbiddenPage.content')}
                 headline={translation.t('errors.forbiddenPage.headline')}
                 button={translation.t('errors.forbiddenPage.button')}/>
    );
  }

}

export default ForbiddenPage;
